/**
* @desc the ngInsuranceOneAxa provides support for displaying information of cancelation insurance in templates. This template is used in Purchase2
* @example <div ng-insurance-one-axa insurance="insurance" passengers="passengers" checked="insuranceselected.isAnnul" insuranceonce="insuranceonce"></div>
*/

webClient.directive('ngInsuranceOneAxa', ['$window', '$timeout', 'templateService', function ($window, $timeout, templateService) {
    var directive = {};
    directive.restrict = 'EA';
    directive.scope = {
        insurance: "=",
        passengers: "=",
        checked: "=",
        insuranceonce: "="
    };
    directive.link = function ($scope, $element) {

        templateService.compile($scope, $element, 'tpl/_Insurance1AxaTPL.html');

        $scope.getUrl = $window.getUrl;
        $scope.siteType = $window.site.type;
        $scope.getStaticFolder = $window.getStaticFolder;
        $scope.getGlobalStaticFolder = $window.getGlobalStaticFolder;
        $scope.getTypeStaticFolder = $window.getTypeStaticFolder;
        $scope.getText = function (key) { return $window.culture.texts[key]; };
        $scope.adults = $window.$scope.bkgData.request.adults;
        $scope.childs = $window.$scope.bkgData.request.childs;
        $scope.infants = $window.$scope.bkgData.request.infants;
        $scope.infantAmount = 0;

        /*Branded Fares*/
        if ($window.$scope.bkgData.bookingRequest && $window.$scope.bkgData.bookingRequest.brandKey)
        {
            $window.$scope.bkgData.brandedFares.brands.any(function (b) {
                if(b.brandKey == $window.$scope.bkgData.bookingRequest.brandKey) {
                    b.insurances.any(function(i) {
                        if (i.insurance == $scope.insurance.insurance) {
                            $scope.insurance.amount = i.amount;
                        }
                    });
                }
            });
        }
        /*End Branded Fares*/

        if ($scope.insurance.infantPaying)
            $scope.infantAmount = $scope.insurance.amount;

        $scope.insurance_int = ($scope.insurance.amount * $scope.insurance.quantity).getIntegers();
        $scope.insurance_dec = ($scope.insurance.amount * $scope.insurance.quantity).getDecimals().padLeft("00");

        /**Select insurance
        * @param {number} item recibe 1 si el usuario agrega el seguro, 0 si lo quita
        */
        $scope.sendValue = function (item) {
            var insuranceTotalValue = 0;
            if (item == 1)
                insuranceTotalValue  = $scope.insurance.amount * $scope.insurance.quantity;
            $scope.$emit("onInsuranceClick", { type: $scope.insurance.insurance, amount: insuranceTotalValue, company: $scope.insurance.company });
        };

        $scope.$on("disableInsurance", function (event, args) {
            if (args.type != $scope.insurance.insurance) {
                $("#i-sellit-1").removeClass("c-sellit-on");
            }
        });

        $timeout(function () {
            if ($scope.checked > 0) {
                $("#i-sellit-1").addClass("c-sellit-on");
                $("input[name=n-radio-b]:first").prop("checked", true);
                var item = $scope.insurance.amount * $scope.insurance.quantity;
                $scope.$emit("onInsuranceClick", { type: $scope.insurance.insurance, amount: item, company: $scope.insurance.company });
            }
            if ($scope.checked == 0 && $scope.insuranceonce == 1) {
                $("#i-sellit-1").removeClass("c-sellit-on");
                $("input[name=n-radio-b]:last").prop("checked", true);
                $scope.$emit("setOnce", {});
            }
        });
    };
    return directive;
}]);
